/* eslint-disable no-multi-assign */
/* eslint-disable no-param-reassign */

export class OMT_UI_AvatarWithFrame extends Phaser.Group {
  /**
   * constructor
   * @param {string} imageURL
   * @param {number} imageSize
   * @param {Array.<string>} defaultFrames
   */
  constructor(imageURL, imageSize, defaultFrames = ['avatar_m', 'avatar_f']) {
    super(game);

    this._imageURL = imageURL;
    this._imageSize = imageSize;
    this._frameSize = Math.round(this._imageSize * 1.1);

    this._initAvatarImage(imageURL, defaultFrames);
    this._initAvatarFrame();
  }

  /**
   * init the user avatar image
   * @param {string} imageURL
   * @param {Array.<string>} defaultFrames
   */
  _initAvatarImage(imageURL, defaultFrames) {
    const defaultFrame = ArrayUtil.getRandomElement(defaultFrames);
    if (imageURL !== null) {
      this._avatarImage = G.makeExtImage(0, 0, this._imageURL, defaultFrame, 0.5, this, false, (image) => {
        image.width = image.height = this._imageSize;
      });
    } else {
      this._avatarImage = G.makeImage(0, 0, defaultFrame, 0.5);
    }
    this._avatarImage.width = this._avatarImage.height = this._imageSize;
    this.addChild(this._avatarImage);
  }

  /**
   * init the avatar frame
   */
  _initAvatarFrame() {
    const frameSize = this._frameSize;
    this._avatarFrame = G.makeImage(0, 0, 'avatar_frame_big', 0.5, null);
    this._avatarFrame.width = this._avatarFrame.height = frameSize;
    this.addChild(this._avatarFrame);
  }
}
